// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ee19da17","732":"e3dcd483","977":"4882e047"}[chunkId] + ".chunk.js";
};